import { render, staticRenderFns } from "./next-button.vue?vue&type=template&id=8c16f028&scoped=true"
import script from "./next-button.vue?vue&type=script&lang=js"
export * from "./next-button.vue?vue&type=script&lang=js"
import style0 from "./next-button.vue?vue&type=style&index=0&id=8c16f028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c16f028",
  null
  
)

export default component.exports